import React from "react";
import { Button, Modal } from "react-bootstrap";

/**
 * Modal de confirmation générique.
 *
 * Props :
 *  - show          : boolean
 *  - onHide        : () => void  — ferme la modal sans action
 *  - onConfirm     : () => void  — appelé quand l'utilisateur confirme
 *  - title         : string      — titre de la modal (défaut : "Confirmation")
 *  - message       : string|node — corps du message
 *  - confirmLabel  : string      — libellé du bouton de confirmation (défaut : "Confirmer")
 *  - confirmVariant: string      — variante Bootstrap du bouton (défaut : "danger")
 */
const ConfirmModal = ({
  show,
  onHide,
  onConfirm,
  title = "Confirmation",
  message,
  confirmLabel = "Confirmer",
  confirmVariant = "danger",
}) => (
  <Modal show={show} onHide={onHide} centered>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{message}</Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>
        Annuler
      </Button>
      <Button variant={confirmVariant} onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ConfirmModal;
